import script from "./WCPaymentOptionBadgeModernCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCPaymentOptionBadgeModernCard.vue?vue&type=script&setup=true&lang=ts"

import "./WCPaymentOptionBadgeModernCard.vue?vue&type=style&index=0&id=570f74fd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-570f74fd"]])

export default __exports__